import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomSelect from './CustomSelect/CustomSelect';
import { getStatesAction } from '../store/location/asyncActions';

const StateSelect = ({ country, value, onChange, error, helperText, user, disabled, required, ...props }) => {
    const dispatch = useDispatch();
    const { states } = useSelector((state) => state.location);

    useEffect(() => {
        if (country?.country_id && !states.loading) {
            dispatch(getStatesAction({ ...user, country_id: country.country_id }));
        }
    }, [dispatch, country]);

    return (
        <CustomSelect
            title="Select State"
            options={states.data?.data || []}
            labelKey="state_name"
            value={value}
            onSelect={onChange}
            error={error}
            helperText={helperText}
            disabled={disabled || !country || states.loading}
            required={required}
            {...props}
        />
    );
};

export default StateSelect;
